import { Outlet, useNavigate } from "react-router-dom";
import {
  BackButton,
  Heading,
  NavTab,
  Responsive,
  TabBar,
} from "@songtradr-one/components-frontend";
import { Flex } from "../flex/Flex.Parts";
import { Restricted } from "../restricted/Restricted";
import {
  Collapsible,
  CollapsibleInner,
  Header,
  HeadingWrapper,
  Props,
  TabbedPageContainer,
} from "./TabbedShell.Parts";

export const TabbedShell = ({
  buttons,
  tabActions,
  className,
  pageTitle,
  pageTitleMaxWidth,
  tabs,
  outletContext,
  back,
  hideCollapsible,
}: Props) => {
  const navigate = useNavigate();

  const content = (
    <>
      <Header>
        {back && <BackButton onClick={() => navigate(back)} />}
        <Flex $align="center" $justify="space-between">
          <HeadingWrapper maxWidth={pageTitleMaxWidth}>
            <Responsive
              mobile={
                <Heading variant="h2" tag="h1">
                  {pageTitle}
                </Heading>
              }
              desktop={<Heading variant="h1">{pageTitle}</Heading>}
            />
          </HeadingWrapper>
          {buttons}
        </Flex>
      </Header>
      <Flex $align="center" $justify="space-between">
        <TabBar>
          {tabs.map((tab, index) => (
            <Restricted
              key={`tab-restricted-${index}`}
              permissions={tab.permissions}
              matchAll={tab.permissionMatchAll}
            >
              <NavTab
                $noWrap
                key={index}
                to={tab.route}
                data-testid={`tab-${tab.slug}`}
                label={tab.label}
              />
            </Restricted>
          ))}
          {tabActions && (
            <Flex
              $alignSelf="center"
              $flex="1"
              $justify="flex-end"
              $gap="0"
              $wrap="nowrap"
            >
              {tabActions}
            </Flex>
          )}
        </TabBar>
      </Flex>
    </>
  );

  return (
    <TabbedPageContainer className={className}>
      {hideCollapsible === undefined ? (
        content
      ) : (
        <Collapsible $hidden={hideCollapsible} inert={hideCollapsible}>
          <CollapsibleInner>{content}</CollapsibleInner>
        </Collapsible>
      )}
      <Outlet context={outletContext} />
    </TabbedPageContainer>
  );
};
